import { ZXCVBNFeedbackWarning } from 'zxcvbn';

export const warningsMap: Map<ZXCVBNFeedbackWarning, string> = new Map<ZXCVBNFeedbackWarning, string>([
  ['', ''],
  ['Straight rows of keys are easy to guess', 'validation.passwordStrength.warnings.straightRowsOfKeysAreEasyToGuess'],
  [
    'Short keyboard patterns are easy to guess',
    'validation.passwordStrength.warnings.shortKeyboardPatternsAreEasyToGuess'
  ],
  ['Repeats like "aaa" are easy to guess', 'validation.passwordStrength.warnings.repeatsLikeAaaAreEasyToGuess'],
  [
    'Repeats like "abcabcabc" are only slightly harder to guess than "abc"',
    'validation.passwordStrength.warnings.repeatsLikeAbcabcabcAreOnlySlightlyHarderToGuessThanAbc'
  ],
  [
    'Sequences like abc or 6543 are easy to guess',
    'validation.passwordStrength.warnings.sequencesLikeAbcOr6543AreEasyToGuess'
  ],
  ['Recent years are easy to guess', 'validation.passwordStrength.warnings.recentYearsAreEasyToGuess'],
  ['Dates are often easy to guess', 'validation.passwordStrength.warnings.datesAreOftenEasyToGuess'],
  ['This is a top-10 common password', 'validation.passwordStrength.warnings.thisIsATop10CommonPassword'],
  ['This is a top-100 common password', 'validation.passwordStrength.warnings.thisIsATop100CommonPassword'],
  ['This is a very common password', 'validation.passwordStrength.warnings.thisIsAVeryCommonPassword'],
  [
    'This is similar to a commonly used password',
    'validation.passwordStrength.warnings.thisIsSimilarToACommonlyUsedPassword'
  ],
  ['A word by itself is easy to guess', 'validation.passwordStrength.warnings.aWordByItselfIsEasyToGuess'],
  [
    'Names and surnames by themselves are easy to guess',
    'validation.passwordStrength.warnings.namesAndSurnamesByThemselvesAreEasyToGuess'
  ],
  [
    'Common names and surnames are easy to guess',
    'validation.passwordStrength.warnings.commonNamesAndSurnamesAreEasyToGuess'
  ]
]);
